import { createFileRoute, redirect } from "@tanstack/react-router";

// Back in Manufacturing (ADR-048, reverting the move of ADR-046): links from
// that time keep working.
export const Route = createFileRoute("/_app/master-data/routings")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/manufacturing/routings", search: search as never, replace: true });
  },
});
